import React from "react";

import CardContent from "@material-ui/core/CardContent";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { styled, useTheme } from "@material-ui/core/styles";
import { AlertProps } from "@material-ui/lab/Alert";
import { Card } from "../Card";
import { Alert } from "../Alert";

export interface Props {
  /** Show an alert with a given severity */
  alertSeverity?: AlertProps["severity"] | "draft" | "withdrawn";
  /** Message for alert shown (must have alertSeverity prop set) */
  alertMessage?: React.ReactNode;
  /** Omits the Card wrapper */
  noWrapWithCard?: boolean;

  noTopBorders?: boolean;
  noBottomBorders?: boolean;
  prepopulated?: boolean;
}

/**
 * Wrapper for a question card with components common among all questions
 */
export default function QuestionCard({
  alertSeverity,
  alertMessage,
  noWrapWithCard,
  noBottomBorders,
  noTopBorders,
  prepopulated,
  children,
}: React.PropsWithChildren<Props>) {
  const theme = useTheme();

  if (noWrapWithCard) {
    return (
      <div>
        {children}
        {alertSeverity && <StyledAlert severity={alertSeverity} message={alertMessage} />}
      </div>
    );
  }

  const cardStyle: React.CSSProperties = {
    ...(noTopBorders && noBottomBorders
      ? { borderRadius: 0 }
      : noTopBorders
      ? { borderTopLeftRadius: 0, borderTopRightRadius: 0 }
      : noBottomBorders
      ? { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }
      : { borderRadius: 4 }),
    ...(prepopulated && {
      border: `1px solid ${theme.palette.info.main}`,
    }),
  };

  return (
    <Card style={cardStyle}>
      <CardContent>
        {children}
        {alertSeverity && <StyledAlert severity={alertSeverity} message={alertMessage} />}
      </CardContent>
    </Card>
  );
}

// eslint-disable-next-line cohere-react/no-mui-styled-import
const StyledAlert = styled(Alert)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));
